<template>
  <div>
    <v-form ref="form">
      <v-text-field
        v-model="form.name"
        class="mx-3"
        label="Nazwa szkolenia"
        name="name"
        type="text"
        :hide-details="!nameErrors.length"
        :error-messages="nameErrors"
        @input="$v.form.name.$touch()"
        @blur="$v.form.name.$touch()"
      />
      <v-checkbox
        v-model="form.isActive"
        class="mx-2"
        :label="form.isActive ? 'Aktywne' : 'Nieaktywne'"
        hide-details
        @change="$v.form.isActive.$touch()"
      />
    </v-form>
    <v-scroll-y-transition>
      <div v-if="formChanged">
        <v-btn class="mt-2" color="primary" text :loading="saving" @click="save">Zatwierdź</v-btn>
        <v-btn class="mt-2" color="error" text :disabled="saving" @click="cancel">Anuluj</v-btn>
      </div>
    </v-scroll-y-transition>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { createNamespacedHelpers } from 'vuex';

const { mapActions } = createNamespacedHelpers('courses');

export default {
  mixins: [validationMixin],
  props: {
    course: {
      type: Object,
      required: true
    }
  },
  data: function() {
    return {
      saving: false,
      form: {
        name: this.course.name,
        isActive: this.course.isActive
      }
    };
  },
  computed: {
    nameErrors() {
      const errors = [];
      if (!this.$v.form.name.$dirty) {
        return errors;
      }
      if (!this.$v.form.name.required) {
        errors.push('Nazwa szkolenia jest wymagana');
      }
      return errors;
    },
    formValid() {
      return !this.$v.form.$invalid && !this.$v.form.$pending;
    },
    formChanged() {
      return this.$v.$anyDirty;
    }
  },
  validations: {
    form: {
      name: {
        required
      },
      isActive: {}
    }
  },
  methods: {
    ...mapActions(['updateCourse']),
    async save() {
      this.$v.$touch();

      if (this.formValid) {
        this.saving = true;
        await this.updateCourse({
          id: this.course.id,
          name: this.form.name,
          isActive: this.form.isActive
        });
        this.saving = false;
        this.cancel();
      }
    },
    cancel() {
      this.$v.$reset();
      this.form.name = this.course.name;
      this.form.isActive = this.course.isActive;
    }
  }
};
</script>

<style scoped></style>
